<!-- eslint-disable -->
<template>
	<div class="sect-intro">
		<h2>{{title}}</h2>
		<p class="note" v-if="text.length !== 0" v-bind:key="p" v-for="p in text">{{p}}</p>
	</div>
</template>

<script>
export default {
	name: 'sectHeader',
	props: {
		title: String,
		text: Array
	}
}
</script>